const getErrorContainer = (ref) => {
    const node = ref?.current;
    if (!node) return null;

    const preferred = node.closest('.floating-label, label, .file-field, .checkbox-container');
    if (preferred) return preferred;

    return node.parentElement ?? null;
};

export const clearErrors = (refs, { reflow = false } = {}) => {
    refs.filter(Boolean).forEach(ref => { //skip null/undefined, conditional fields are safe
        const el = getErrorContainer(ref);
        if (!el) return;
        el.classList.remove('error');
        if (reflow) void el.offsetWidth;
    });
};

export const markError = (ref, { focus = false, scroll = false } = {}) => {
    const el = getErrorContainer(ref);
    if (!el) return;

    el.classList.add('error');

    if (scroll) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (focus && ref.current?.focus) {
        ref.current.focus();
    }
};

export const emailValid = (ref, validateEmailFn) => {
    const v = ref?.current?.value ?? '';
    return validateEmailFn(v);
};

export const checkboxChecked = (ref) => {
    return !!ref?.current?.checked;
};

export const required = (ref) => {
    const v = ref?.current?.value ?? '';
    return String(v).trim() !== '';
};

export const validateEmail = (email) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}